import { render, staticRenderFns } from "./Drydock.vue?vue&type=template&id=63963980&scoped=true&"
import script from "./Drydock.vue?vue&type=script&lang=js&"
export * from "./Drydock.vue?vue&type=script&lang=js&"
import style0 from "./Drydock.vue?vue&type=style&index=0&id=63963980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63963980",
  null
  
)

export default component.exports